import { useHubspotTrackEvent } from "@tudigo-monorepo/tudigo-session";
import type { ComparatorUrlState } from "@tudigo-monorepo/web-tudigo-comparator";
import {
  HubspotEventEnum,
  useAnalytics,
} from "@tudigo-monorepo/web-tudigo-tracking";

export function useProjectsComparatorTracking() {
  const trackProjectsComparisonDone = useHubspotTrackEvent(
    HubspotEventEnum.PROJECTS_COMPARISON_DONE,
  );

  const analytics = useAnalytics();

  const preparePayload = (
    state: ComparatorUrlState,
  ): Record<string, string | undefined> | undefined => {
    if (state.mode !== "comparison") {
      return; // not tracking unless its comparison mode
    }
    if (state.amount === null) {
      return; // not tracking until amount is defined
    }

    return {
      url: window.location.href,
      projects: state.selection?.toString() ?? undefined,
      amount: state.amount?.toString(),
    };
  };

  return (state: ComparatorUrlState) => {
    const payload = preparePayload(state) ?? {};
    analytics.track("ui.comparator.compare", payload);
    trackProjectsComparisonDone?.(payload);
  };
}
